<div class="margin-folder margin-br d-flex flex-column primary-bg-300 overflow-hidden">
    <div class="icon-margin d-grid place-items-center primary-bg-100 d-flex justify-content-center p-4">
        <ng-content></ng-content>
    </div>
</div>
